<script type="text/javascript" src="cordova.js"></script>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
//import DatePicker from "vue2-datepicker";
//import NumberInputSpinner from "vue-number-input-spinner";
import Swal from "sweetalert2";
import axios from 'axios';
import error403 from '../utility/error-403';

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import {
  required,
  requiredIf,
  email,
  sameAs,
  minLength,
  maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum,
  //requiredIf
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "AutoShop customer registration",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, error403, VuePhoneNumberInput /*DatePicker, NumberInputSpinner*/ },
  props:{
    id:[Number,null],
    rights: Array
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Management",
          href: "/"
        },
        {
          text: "New Customer",
          active: true
        }
      ],

      tabIndex:  0,
      
      form: {
        nm_company:                 "",
        de_companyShortAddress:     "",
        de_companyContactEmail:     "",
        num_companyContactPhone:    "",
        id_country:                 "",
        id_state:                   "",
        nm_city:                    "",
        de_address:                 "",
        de_siteRepresentantEmail:   "",
        de_siteHumanResourcesEmail: "",
        de_siteContactEmail:        "",
        nm_site:                    "",
        nm_employee:                "",
        nm_lastName:                "",
        num_employeeAge:            "",
        id_gender:                  "",
        id_role:                    "",
        de_language:                "",
        de_phoneNumber:             "",
        num_rfc:                    "",
        id_suscriptionType:         "",
      },
      platform:     "",
      phone:        "",

      okPassword:   true,
      submitted:    false,
      validToken:   true,
      validAccess:  true,
      user:         {},
      countries:    [],
      states:       [],
      sites:        [],
      roles:        [],
    };
  },
  validations: {
    form: {
      nm_company:                     { required },
      de_companyShortAddress:         { required },
      de_companyContactEmail:         { required, email },
      num_companyContactPhone:        { required },
      id_country:                     { required },
      id_state:                       { required },
      de_address:                     { required },
      de_siteRepresentantEmail:       { required, email },
      de_siteHumanResourcesEmail:     { required, email },
      de_siteContactEmail:            { required, email },
      nm_site:                        { required },
      nm_employee:                    { required },
      nm_lastName:                    { required },
      num_employeeAge:                { required },
      id_gender:                      { required },
      id_role:                        { required },
      de_language:                    { required },
      num_rfc:                        { required },
      id_suscriptionType:             { required },
      de_password:                    {
        required: requiredIf(function(){return !this.$route.params.id;}),
        minLength: minLength(8),
      },
      de_rePassword:                  { required: requiredIf(function(){return !this.$route.params.id;}), sameAsPassword: sameAs("de_password") },
    }
  },
  watch:{
    validToken(newValue){
      if( newValue == false ){
        this.$bvModal.show('loginModal');
      }
    },
    "rights": function(newvalue, oldvalue){
      if(oldvalue !== newvalue){
        if(!newvalue.includes(this.user.user.id_role)){
          this.validAccess = false;
        }else{
          this.validAccess = true;
        }
      }
    }
  },
  created(){
    if(localStorage){
      this.user = JSON.parse( localStorage.getItem('user') );
    }
  },
  mounted() {
    this.getRoles();
    this.getCountries();
    document.addEventListener("deviceready", this.onDeviceReady, false);
  },
  methods: {
    onDeviceReady(){
      let platform = device.platform;

      if(platform){
        this.platform = platform
      }
    },

    setOtherEmails(){
      this.form.num_rfc                      = this.form.num_rfc.toUpperCase();
      this.form.de_siteRepresentantEmail     = this.form.de_companyContactEmail;
      this.form.de_siteHumanResourcesEmail   = this.form.de_companyContactEmail;
      this.form.de_siteContactEmail          = this.form.de_companyContactEmail;
    },

    validatePassword(event){
      const containsUppercase = /[A-Z]/.test(event.target.value);
      const containsLowercase = /[a-z]/.test(event.target.value);
      const containsNumber = /[0-9]/.test(event.target.value);
      const containsSpecial = /[#?!@$%^&*-]/.test(event.target.value);

      if( this.form.de_password != ""){
        if( containsUppercase && containsLowercase && containsNumber && containsSpecial ){
          this.okPassword = true;
        }else{
          this.okPassword = false;
        }
      }else{
        this.okPassword = false;
      }
      //return this.okPassword;
    },

    async getRoles(){
      Swal.fire({
        title: "Loading roles.",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      let app = this;
      axios
      .get(
         window.serverPath+'dist/mvw/controllers/users.php',
        {
          params: {
            request: 'getUsersRoles',
            token: this.user.token,
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          if( response.data == 'Invalid token' ){
            this.validToken = false;
          }else{
            app.roles = response.data;
            Swal.close();
          }
        }else{
          Swal.fire("Ooops!", "It was nor possible to load Countries! Please load this module again.", "error");
        }
      });
    },

    getCountries(){
      Swal.fire({
        title: "Loading Countries",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      let app = this;
      axios
      .get(
        window.serverPath+'/dist/mvw/controllers/countries.php',
        {
          params: {
            request: 'getCountries',
            token: this.user.token,
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          if( response.data == 'Invalid token' ){
            this.validToken = false;
          }else{
            app.countries = response.data;
            Swal.close();
            if(this.$route.params.id){
              this.getStatesByCountryID();
            }
          }
        }else{
          Swal.fire("Ooops!", "It was nor possible to load Countries! Please load this module again.", "error");
        }
      });
    },
    getStatesByCountryID(){
      let app = this;
      Swal.fire({
        title: "Loading States",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });

      axios
      .get(
        window.serverPath+'/dist/mvw/controllers/states.php',
        {
          params: {
            request: 'getStatesByCountryID',
            idCountry: this.form.id_country,
            token: this.user.token,
          }
        }
      )
      .then(response => {
        if(response.status == 500){ app.$router.push({ name: 'Error-500' }); }
        if(response.status == 404){ app.$router.push({ name: 'Error-404' }); }
        if(response.status == 401){ app.$router.push({ name: 'Error-401' }); }

        if( response.status == 200 ){
          if( response.data == 'Invalid token' ){
            this.validToken = false;
          }else{
            app.states = response.data;
            Swal.close();
          }
        }else{
          Swal.fire("Ooops!", "It was nor possible to load States! Please load this module again.", "error");
        }
      });
    },

    // eslint-disable-next-line no-unused-vars
    saveCustomer(e) {
      let app = this;

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      
      if( !this.$v.form.$error ){
        if( this.$route.params.id ){
          this.form.id_labor = this.$route.params.id;
        }

        Swal.fire({
          title: "Saving labor.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/customers.php', {
          request: 'saveASCustomer',
          data: this.form,
          token: this.user.token,
        })
        .then(function (response) {
          if( response.data == 'Invalid token' ){
            this.validToken = false;
          }else{
            let action = "";
            if( response.data === "OK" ){
              action = "saved";
            }
            if( response.data === "UPDATED" ){
              action = "updated";
            }

            Swal.fire("Good job!", "The new customer is properly "+action+"!<br>Now they can use the system.<br>An email was sent to the provided email noticing the customer their account is already setup.", "success");
            app.$router.push({ name: 'labors' });
          }
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });
      }else{
        console.log(this.$v.form);
      }
    },

    onUpdate(payload){
      this.form.num_contactPhoneNumber = payload.formattedNumber;
      this.form.de_phoneNumber = payload;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div v-if="validAccess"  class="card-body">
            <form class="needs-validation" @submit.prevent="saveCustomer">
              <h4 class="card-title">{{ $t('menuitems.management.list.newCustomer') }}</h4>
              <p class="card-title-desc">{{ $t('menuitems.management.list.newCustomerDescription') }}</p>
              <b-tabs
                pills
                :vertical="(platform) ? false : true"
                nav-class="p-0"
                nav-wrapper-class="col-sm-3"
                content-class="pt-0 px-2 text-muted"
                v-model="tabIndex"
              >
                <b-tab :title="$t('menuitems.management.list.tabCompany')" active title-item-class="mb-2">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="nm_company">{{ $t('menuitems.management.list.companyName') }}</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_company.$error }"
                          name="nm_company"
                          id="nm_company"
                          v-model="form.nm_company"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_company.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_company.required">Company name is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_companyShortAddress">{{ $t('menuitems.management.list.companyShortAddress') }}</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_companyShortAddress.$error }"
                          name="de_companyShortAddress"
                          id="de_companyShortAddress"
                          v-model="form.de_companyShortAddress"
                          value=""
                        >
                        <span>{{ $t('menuitems.management.list.companyShortAddressMuted') }}</span>
                        <div v-if="submitted && $v.form.de_companyShortAddress.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_companyShortAddress.required">Company short address is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_companyFullAddress">{{ $t('menuitems.management.list.companyFullAddress') }}</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_companyFullAddress.$error }"
                          name="de_companyFullAddress"
                          id="de_companyFullAddress"
                          v-model="form.de_companyFullAddress"
                          value=""
                        >
                        <span>{{ $t('menuitems.management.list.companyFullAddressMuted') }}</span>
                        <div v-if="submitted && $v.form.de_companyFullAddress.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_companyFullAddress.required">Company full address is required for invoicing.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="num_rfc">{{ $t('menuitems.management.list.rfc') }}</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.num_rfc.$error }"
                          name="num_rfc"
                          id="num_rfc"
                          v-model="form.num_rfc"
                          value=""
                          @change="setOtherEmails"
                        >
                        <!--<span class="text-purple">City, State, Country</span>-->
                        <div v-if="submitted && $v.form.num_rfc.$error" class="invalid-feedback">
                          <span v-if="!$v.form.num_rfc.required">This field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_companyContactEmail">{{ $t('menuitems.management.list.companyContactEmail') }}</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_companyContactEmail.$error }"
                          name="de_companyContactEmail"
                          id="de_companyContactEmail"
                          v-model="form.de_companyContactEmail"
                          value=""
                          @change="setOtherEmails"
                        >
                        <!--<span class="text-purple">City, State, Country</span>-->
                        <div v-if="submitted && $v.form.de_companyContactEmail.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_companyContactEmail.required">Company contact email is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="num_companyContactPhone">{{ $t('menuitems.management.list.companyContactPhoneNumber') }}</label>
                        <!--
                        <input
                          v-mask="'+(##) ###-###-####'"
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.num_companyContactPhone.$error }"
                          name="num_companyContactPhone"
                          id="num_companyContactPhone"
                          v-model="form.num_companyContactPhone"
                        />
                        
                        <vue-tel-input
                          :class="{ 'is-invalid': submitted && $v.form.num_companyContactPhone.$error }"
                          name="num_companyContactPhone"
                          id="num_companyContactPhone"
                          v-model="form.num_companyContactPhone"
                        ></vue-tel-input>
                        -->
                        <VuePhoneNumberInput
                          :class="{ 'is-invalid': submitted && $v.form.num_companyContactPhone.$error }"
                          name="num_companyContactPhone"
                          id="num_companyContactPhone"
                          v-model="form.num_companyContactPhone"
                          @update="onUpdate"
                        />

                        <!--<span class="text-muted">e.g "(xx) xxxx-xxxx"</span>-->
                        <div v-if="submitted && $v.form.num_companyContactPhone.$error" class="invalid-feedback">
                          <span v-if="!$v.form.num_companyContactPhone.required">Company contact phone is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_suscriptionType">{{$t('menuitems.management.list.suscriptionType')}}</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_suscriptionType.$error }"
                          name="id_suscriptionType"
                          id="id_suscriptionType"
                          v-model="form.id_suscriptionType"
                        >
                          <option value="">{{$t('menuitems.management.list.selectSuscriptionType')}}</option>
                          <option value="0">{{$t('menuitems.management.list.free')}}</option>
                          <option value="1">{{$t('menuitems.management.list.small')}}</option>
                          <option value="2">{{$t('menuitems.management.list.medium')}}</option>
                          <option value="3">{{$t('menuitems.management.list.high')}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_suscriptionType.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_suscriptionType.required">Suscription type is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>

                <b-tab :title="$t('menuitems.management.list.tabSite')" title-item-class="mb-2">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="id_country">{{$t('menuitems.management.list.country')}}</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_country.$error }"
                          name="id_country"
                          id="id_country"
                          v-model="form.id_country"
                          @change="getStatesByCountryID"
                        >
                          <option value="">{{$t('menuitems.management.list.selectCountry')}}</option>
                          <option value="142">México</option>
                          <option value="231">United States</option>
                          <hr>
                          <option v-for="(country, index) in countries" :key="index" :value="country.id_country">{{country.nm_country}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_country.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_country.required">Country field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_state">{{$t('menuitems.management.list.state')}}</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_state.$error }"
                          name="id_state"
                          id="id_state"
                          v-model="form.id_state"
                          value=""
                        >
                          <option value="">{{$t('menuitems.management.list.selectState')}}</option>
                          <option v-for="(state, index) in states" :key="index" :value="state.id_state">{{state.nm_state}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_state.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_state.required">State/Province field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_address">{{$t('menuitems.management.list.address')}}</label>
                        <textarea
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_address.$error }"
                          name="de_address"
                          id="de_address"
                          v-model="form.de_address"
                          rows="3"
                          value=""
                        >
                        </textarea>
                        <span>{{$t('menuitems.management.list.addressMuted')}}</span>
                        <div v-if="submitted && $v.form.de_address.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_address.required">Address field is required.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="de_siteRepresentantEmail">{{$t('menuitems.management.list.representantEmail')}}</label>
                        <input
                          type="email"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_siteRepresentantEmail.$error }"
                          name="de_siteRepresentantEmail"
                          id="de_siteRepresentantEmail"
                          v-model="form.de_siteRepresentantEmail"
                          value=""
                        >
                        <div v-if="submitted && $v.form.de_siteRepresentantEmail.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_siteRepresentantEmail.required">Representant email is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_siteHumanResourcesEmail">{{$t('menuitems.management.list.humanResourcesEmail')}}</label>
                        <input
                          type="email"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_siteHumanResourcesEmail.$error }"
                          name="de_siteHumanResourcesEmail"
                          id="de_siteHumanResourcesEmail"
                          v-model="form.de_siteHumanResourcesEmail"
                          value=""
                        >
                        <div v-if="submitted && $v.form.de_siteHumanResourcesEmail.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_siteHumanResourcesEmail.required">Human Resources email is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_siteContactEmail">{{$t('menuitems.management.list.contactEmail')}}</label>
                        <input
                          type="email"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_siteContactEmail.$error }"
                          name="de_siteContactEmail"
                          id="de_siteContactEmail"
                          v-model="form.de_siteContactEmail"
                          value=""
                        >
                        <div v-if="submitted && $v.form.de_siteContactEmail.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_siteContactEmail.required">Contact email is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="nm_site">{{$t('menuitems.management.list.siteName')}}</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_site.$error }"
                          name="nm_site"
                          id="nm_site"
                          v-model="form.nm_site"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_site.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_site.required">Site name is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>

                <b-tab :title="$t('menuitems.management.list.tabEmployee')" title-item-class="mb-2">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="nm_employee">{{$t('menuitems.management.list.employeeName')}}</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_employee.$error }"
                          name="nm_employee"
                          id="nm_employee"
                          v-model="form.nm_employee"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_employee.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_employee.required">Employee name is required.</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="nm_lastName">{{$t('menuitems.management.list.employeeLastName')}}</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_lastName.$error }"
                          name="nm_lastName"
                          id="nm_lastName"
                          v-model="form.nm_lastName"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_lastName.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_lastName.required">Employee last name is required.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="num_employeeAge">{{$t('menuitems.management.list.employeeAge')}}</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.num_employeeAge.$error }"
                          name="num_employeeAge"
                          id="num_employeeAge"
                          v-model="form.num_employeeAge"
                          value=""
                        />
                        <div v-if="submitted && $v.form.num_employeeAge.$error" class="invalid-feedback">
                          <span v-if="!$v.form.num_employeeAge.required">Employee age is required.</span>
                          <span v-if="!$v.form.num_employeeAge.minValue">This minimum age is invalid. It should be between 18 and 100 years old.</span>
                          <span v-if="!$v.form.num_employeeAge.maxValue">This maximum age is invalid. It should be between 18 and 100 years old.</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="id_gender">{{$t('menuitems.management.list.gender')}}</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_gender.$error }"
                          name="id_gender"
                          id="id_gender"
                          v-model="form.id_gender"
                        >
                          <option value="">{{$t('menuitems.management.list.selectGender')}}</option>
                          <option value="0">{{$t('menuitems.management.list.female')}}</option>
                          <option value="1">{{$t('menuitems.management.list.male')}}</option>
                          <option value="2">{{$t('menuitems.management.list.noneBinary')}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_gender.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_gender.required">Gender is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>

                <b-tab :title="$t('menuitems.management.list.tabUser')" title-item-class="mb-2">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="id_role">{{$t('menuitems.management.list.role')}}</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_role.$error }"
                          name="id_role"
                          id="id_role"
                          v-model="form.id_role"
                        >
                          <option value="">{{$t('menuitems.management.list.selectRole')}}</option>
                          <option v-for="(role, index) in roles" :key="index" :value="role.id_role">{{role.nm_role}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_role.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_role.required">Site is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_language">{{$t('menuitems.users.list.language')}}</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_language.$error }"
                          name="de_language"
                          id="de_language"
                          v-model="form.de_language"
                        >
                          <option value="">{{$t('menuitems.users.list.selectLanguage')}}</option>
                          <option value="en">{{$t('menuitems.users.list.english')}}</option>
                          <option value="es">{{$t('menuitems.users.list.spanish')}}</option>
                        </select>
                        <div v-if="submitted && $v.form.de_language.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_language.required">Language is required.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="de_password">{{$t('menuitems.management.list.password')}}</label>
                        <input
                          v-model="form.de_password"
                          type="password"
                          name="de_password"
                          class="form-control"
                          :class="{ 'is-invalid': (submitted && $v.form.de_password.$error) || (!okPassword) }"
                          placeholder="Password"
                          v-on:keypress="validatePassword"
                        />
                        <div v-if="(submitted && $v.form.de_password.$error) || (!okPassword)" class="invalid-feedback">
                          <span v-if="!$v.form.de_password.required">This value is required.</span>
                          <span v-if="!$v.form.de_password.minLength">Password must be at least / characters.</span>
                          <span v-if="!okPassword">
                            Password must content at least 1 Capital, 1 minus, 1 digit and at least 1 of those simbols #?!@$%^&*-
                          </span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_password">{{$t('menuitems.management.list.repeatPassword')}}</label>
                        <input
                          v-model="form.de_rePassword"
                          type="password"
                          name="de_rePassword"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_rePassword.$error }"
                          :placeholder="$t('menuitems.management.list.repeatPasswordPlaceholder')"
                        />

                        <div
                          v-if="submitted && $v.form.de_rePassword.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.form.de_rePassword.required">Password is required.</span>
                          <span
                            v-else-if="!$v.form.de_rePassword.sameAsPassword"
                          >This value should be the same.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>

              </b-tabs>

              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button v-if="tabIndex < 3" class="btn btn-primary mr-3" type="button" @click="tabIndex++">Siguiente/Next</button>
                    <button v-else class="btn btn-success mr-3" type="submit">{{$t('menuitems.management.list.save')}}</button>
                    <button v-if="tabIndex > 0 && tabIndex < 3" class="btn btn-primary" type="button" @click="tabIndex--">Atras/Previous</button>

                    <router-link to="/shop/labors" class="ml-3">
                      <button class="btn btn-danger" type="reset">{{$t('menuitems.management.list.cancel')}}</button>
                    </router-link>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div v-else class="card-body">
            <div class="row">
              <div class="col-sm-12 text-center">
                <error403></error403>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </Layout>
</template>

<style type="text/css">
  .is-invalid  .mx-input{
    border: solid 1px red !important;
  }
</style>